import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Icon, Intent, InputGroup, Text } from '@blueprintjs/core';
import { v4 as uuidv4 } from 'uuid';

import Clearfix from 'components/elements/clearfix';
import { IconNames } from '@blueprintjs/icons';
import styled from 'styled-components';
//* ------------------------ */
import IconRequired from 'components/elements/required-icon';
import SelectLoaiHoaChat from 'components/elements/select-loai-hoa-chat';

import { COLOR } from 'config';
import _ from 'lodash';

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const FIELD = {
  key: 'key',
  chemistry: 'chemistry',
  moreInfo: 'moreInfo',
};
class WasteProfile extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
  };

  state = {
    isChange: false,
    dataChemistry: null,
    listDataChemistry: [
      {
        [FIELD.key]: uuidv4(),
        [FIELD.chemistry]: null,
        [FIELD.moreInfo]: null,
      },
    ],
  };

  handleProperty = (key, value, indexParent) => {
    let moreInfo = this.state.dataChemistry
      ? this.state.dataChemistry[FIELD.moreInfo]
      : {};
    const item = {
      ...this.state.dataChemistry,
      [FIELD.moreInfo]: {
        ...moreInfo,
        [key]: value.target.value,
      },
    };
    this.setState({
      dataChemistry: item,
    });

    this.updateListDataChemistry(indexParent, item);
  };

  renderMoreInfo = (dataChemistry, indexParent) => {
    let chemistry = _.get(dataChemistry, [FIELD.chemistry], '');
    let moreInfo = [];

    if (!chemistry) {
      return null;
    }

    moreInfo = _.get(chemistry[0], 'moreInfo', []);
    return _.map(moreInfo, (item, index) => {
      return (
        <React.Fragment key={index}>
          <Clearfix height={8} />
          <Row>
            <Col xs={4}>
              <LabelContainer>{item.name}</LabelContainer>
            </Col>
            <Col xs={4}>
              <InputGroup
                onFocus={() => {
                  this.setState({
                    dataChemistry: dataChemistry,
                  });
                }}
                defaultValue={
                  dataChemistry.moreInfo ? dataChemistry.moreInfo[item.key] : ''
                }
                placeholder={item.name}
                onChange={(value) =>
                  this.handleProperty(item.key, value, indexParent)
                }
              />
            </Col>
          </Row>
        </React.Fragment>
      );
    });
  };

  handleOnChangeHoaChat = (value, index) => {
    const item = {
      ...this.state.listDataChemistry[index],
      [FIELD.chemistry]: value,
    };

    this.setState({
      dataChemistry: item,
    });

    this.updateListDataChemistry(index, item);
  };

  onClickAdd = () => {
    let arr = this.state.listDataChemistry;
    const item = {
      [FIELD.key]: uuidv4(),
      [FIELD.chemistry]: null,
      [FIELD.moreInfo]: null,
    };
    arr.push(item);
    this.setState({
      listDataChemistry: arr,
      dataChemistry: item,
    });
  };
  onClickDelete = (index) => {
    let data = this.state.listDataChemistry;
    delete data[index];
    const listDataChemistry = _.compact(data);
    this.setState({
      listDataChemistry: listDataChemistry,
      isChange: true,
      dataChemistry: listDataChemistry[listDataChemistry.length - 1],
    });
  };

  updateListDataChemistry = (index, objValue) => {
    let data = this.state.listDataChemistry;
    data[index] = objValue;
    this.setState({
      listDataChemistry: data,
      isChange: true,
    });
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.isChange) {
      if (this.props.onChange) {
        const data = _.map(this.state.listDataChemistry, (item) => {
          if (item.chemistry) {
            return item;
          } else {
            return null;
          }
        });
        this.props.onChange(_.compact(data));
        this.setState({
          isChange: false,
        });
      }
    }
  };

  componentDidMount = () => {
    if (this.props.value) {
      this.setState({
        listDataChemistry: this.props.value,
        dataChemistry: this.props.value[0],
        isChange: true,
      });
    }
  };

  render() {
    return (
      <div>
        {this.state.listDataChemistry &&
          _.map(this.state.listDataChemistry, (item, index) => {
            const initialvalueHoaChat = [];
            const defaultChemistry = _.get(item, [FIELD.chemistry]);
            if (defaultChemistry) {
              if (_.get(defaultChemistry[0], ['Name'], '')) {
                initialvalueHoaChat.push(
                  _.get(defaultChemistry[0], ['Name'], '')
                );
              }
              if (_.get(defaultChemistry[1], ['Name'], '')) {
                initialvalueHoaChat.push(
                  _.get(defaultChemistry[1], ['Name'], '')
                );
              }
            }

            return (
              <React.Fragment key={item[FIELD.key]}>
                <Clearfix height={8} />
                <Row>
                  <Col xs={4}>
                    <LabelContainer>
                      Loại chất thải
                      <IconRequired />
                    </LabelContainer>
                  </Col>
                  <Col xs={4}>
                    <SelectLoaiHoaChat
                      initialvalue={initialvalueHoaChat.join(` / `)}
                      onChange={(value) =>
                        this.handleOnChangeHoaChat(value, index)
                      }
                    />
                  </Col>
                </Row>

                {this.renderMoreInfo(item, index)}
                {this.state.listDataChemistry.length > 1 && (
                  <Row>
                    <Col xs={4}></Col>
                    <Col xs={4}>
                      <div
                        onClick={() => this.onClickDelete(index)}
                        style={{
                          cursor: 'pointer',
                          float: 'right',
                          display: 'flex',
                          alignItems: 'center',
                          color: COLOR.SUCCESS,
                        }}
                      >
                        <Text>
                          <Icon
                            icon={IconNames.DISABLE}
                            intent={Intent.DANGER}
                          />
                        </Text>
                        <Clearfix width={4} />
                        <Text>Xóa loại chất thải</Text>
                      </div>
                    </Col>
                  </Row>
                )}
              </React.Fragment>
            );
          })}
        {this.state.dataChemistry && this.state.dataChemistry[FIELD.chemistry] && (
          <Row>
            <Col xs={4}></Col>
            <Col xs={4}>
              <div
                onClick={this.onClickAdd}
                style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  color: COLOR.SUCCESS,
                  width: 'fit-content',
                }}
              >
                <Text>
                  <Icon icon={IconNames.ADD} intent={Intent.SUCCESS} style={{ color: COLOR.SUCCESS }} />
                </Text>
                <Clearfix width={4} />
                <Text>Thêm loại chất thải</Text>
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export default WasteProfile;



// WEBPACK FOOTER //
// ./src/containers/environment-protection-work/environment-protection-work-Form/waste-profile/index.js